<template>
  <div>
    The semi-major-axis tolerance is defined as follows :
    <br />
    <br />
    <v-img
      contain
      :src="require('../../../assets/images/tooltip-sma-top-bottom-margin.png')"
      aspect-ratio="2.5"
    />
    <br />
    <br />
    Note that the minimal value for the semi-major-axis tolerance is 100m.
  </div>
</template>

<script>
export default {
  name: 'tooltipSmaTopBottomMargin'
}
</script>
